import _memoize from "lodash/memoize";
import { fetchUserAttributes } from 'aws-amplify/auth';

// Amplify v6 hits Cognito's GetUser on every fetchUserAttributes call, unlike v5 which cached
// the user data. Caching the promise also collapses concurrent calls into a single request.
// Clear the cache after modifying user attributes.
var fetchUserAttributesCached = _memoize(function () {
  return fetchUserAttributes().catch(function (e) {
    fetchUserAttributesCached.cache.clear();
    throw e;
  });
});
export default fetchUserAttributesCached;